/* Tomatosharp Editorial V2 — samtykke til informasjonskapsler.
   Bruker Shopifys Customer Privacy API. Erstatter Shopifys eget cookie-banner,
   som må slås av under Innstillinger > Kundepersonvern i admin.

   Regler som styrer logikken (Datatilsynets veiledning til ekomloven § 3-15):
   ingen lagring før aktivt valg, ingen forhåndsavkryssede brytere, ingen
   aksept ved passivitet, og samtykket kan trekkes tilbake like enkelt som det
   ble gitt. */

(function () {
  var FORMAAL = ['analytics', 'marketing', 'preferences'];

  var banner = document.querySelector('[data-cookie-banner]');
  var panel = document.querySelector('[data-cookie-panel]');
  if (!banner || !panel) return;

  var personvern = null;
  var sisteFokus = null;

  function lastApi(naar) {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (feil) {
        if (feil) return;
        personvern = window.Shopify.customerPrivacy;
        if (personvern) naar();
      }
    );
  }

  function visBanner() {
    banner.hidden = false;
  }

  function skjulAlt() {
    banner.hidden = true;
    panel.hidden = true;
    document.documentElement.style.removeProperty('overflow');
  }

  function lagre(valg) {
    if (!personvern) return skjulAlt();

    personvern.setTrackingConsent(
      {
        analytics: valg.analytics,
        marketing: valg.marketing,
        preferences: valg.preferences,
        sale_of_data: valg.marketing
      },
      function () {
        skjulAlt();
        if (sisteFokus && document.contains(sisteFokus)) sisteFokus.focus();
      }
    );
  }

  function alle(verdi) {
    return { analytics: verdi, marketing: verdi, preferences: verdi };
  }

  function lesBrytere() {
    var valg = {};
    FORMAAL.forEach(function (navn) {
      var felt = panel.querySelector('[data-cookie-formaal="' + navn + '"]');
      valg[navn] = !!(felt && felt.checked);
    });
    return valg;
  }

  function settBrytere(valg) {
    FORMAAL.forEach(function (navn) {
      var felt = panel.querySelector('[data-cookie-formaal="' + navn + '"]');
      if (felt) felt.checked = !!(valg && valg[navn]);
    });
  }

  /* shouldShowBanner() sier bare at regionen krever samtykke. Den slår ikke av
     når besøkende har svart, så vi sjekker svaret selv. Tom streng betyr at
     valget ikke er tatt. */
  function harSvart() {
    if (!personvern || typeof personvern.currentVisitorConsent !== 'function') return false;

    var svar = personvern.currentVisitorConsent() || {};

    return ['analytics', 'marketing', 'preferences', 'sale_of_data'].some(function (navn) {
      return svar[navn] === 'yes' || svar[navn] === 'no';
    });
  }

  function naavaerendeValg() {
    if (!personvern || typeof personvern.currentVisitorConsent !== 'function') return null;

    var svar = personvern.currentVisitorConsent();
    if (!svar) return null;

    return {
      analytics: svar.analytics === 'yes',
      marketing: svar.marketing === 'yes',
      preferences: svar.preferences === 'yes'
    };
  }

  function aapnePanel() {
    sisteFokus = document.activeElement;
    settBrytere(naavaerendeValg());
    panel.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    var forste = panel.querySelector('input, button');
    if (forste) forste.focus();
  }

  function lukkPanel() {
    panel.hidden = true;
    document.documentElement.style.removeProperty('overflow');
    if (banner.hidden === false) {
      var knapp = banner.querySelector('[data-cookie-godta]');
      if (knapp) knapp.focus();
    } else if (sisteFokus && document.contains(sisteFokus)) {
      sisteFokus.focus();
    }
  }

  /* Fokusfelle i panelet. Escape lukker panelet, men avgir ikke noe samtykke. */
  panel.addEventListener('keydown', function (hendelse) {
    if (hendelse.key === 'Escape') {
      hendelse.preventDefault();
      lukkPanel();
      return;
    }
    if (hendelse.key !== 'Tab') return;

    var felter = panel.querySelectorAll('button, input, a[href]');
    if (!felter.length) return;

    var forste = felter[0];
    var siste = felter[felter.length - 1];

    if (hendelse.shiftKey && document.activeElement === forste) {
      hendelse.preventDefault();
      siste.focus();
    } else if (!hendelse.shiftKey && document.activeElement === siste) {
      hendelse.preventDefault();
      forste.focus();
    }
  });

  banner.addEventListener('click', function (hendelse) {
    var maal = hendelse.target.closest('button');
    if (!maal) return;

    if (maal.hasAttribute('data-cookie-godta')) lagre(alle(true));
    if (maal.hasAttribute('data-cookie-avvis')) lagre(alle(false));
    if (maal.hasAttribute('data-cookie-velg')) aapnePanel();
  });

  panel.addEventListener('click', function (hendelse) {
    var maal = hendelse.target.closest('button');
    if (!maal) return;

    if (maal.hasAttribute('data-cookie-lagre')) lagre(lesBrytere());
    if (maal.hasAttribute('data-cookie-avvis-alle')) lagre(alle(false));
    if (maal.hasAttribute('data-cookie-lukk')) lukkPanel();
  });

  /* Fotlenken lar besøkende endre eller trekke tilbake samtykket når som helst. */
  function koblePaaFotlenke() {
    document.addEventListener('click', function (hendelse) {
      var utloser = hendelse.target.closest('[data-cookie-innstillinger]');
      if (!utloser) return;

      hendelse.preventDefault();
      if (!personvern) {
        lastApi(aapnePanel);
        return;
      }
      aapnePanel();
    });
  }

  function byggFotlenke() {
    if (document.querySelector('[data-cookie-innstillinger]')) return;

    var vert = document.querySelector('.footer__aside, .footer__base-links, .footer__inner, .site-footer');
    if (!vert) return;

    var knapp = document.createElement('button');
    knapp.type = 'button';
    knapp.className = 'v2-cookie-fotlenke';
    knapp.setAttribute('data-cookie-innstillinger', '');
    knapp.textContent = 'Informasjonskapsler';

    var boks = document.createElement('div');
    boks.className = 'v2-cookie-fotlenke-boks';
    boks.appendChild(knapp);
    vert.appendChild(boks);
  }

  function start() {
    koblePaaFotlenke();
    byggFotlenke();

    /* Butikken selger til Norge, der samtykke kreves uansett. Vi bruker derfor
       ikke shouldShowBanner() som port: den henger sammen med Shopifys egen
       banner-konfigurasjon, og hvis den slår om til false står butikken uten
       samtykkeboks. Eneste spørsmål som avgjør visning: har besøkende svart? */
    lastApi(function () {
      if (!harSvart()) visBanner();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
